import React, { useState } from 'react'
import styled from '@emotion/styled'
import { useSelector } from 'react-redux'
import { useQuery } from '@apollo/react-hooks'
import { GET_SCENARIO_ATTACKS } from '../../queries/scenario'

const Container = styled.a`
  color: rgba(0, 0, 0, 0.87);
  font-weight: bold;
`

const convertAttacksToCSV = objArray => {
  var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray
  var str = ''

  for (var i = 0; i < array.length; i++) {
    var line = ''
    line += `${array[i]['name']}, ${array[i]['path_length']}`
    for (var segment in array[i]['breakdown']) {
      line += `,${array[i]['breakdown'][segment].summary}`
    }
    str += line + '\r\n'
  }

  return str
}

const prepareAttacksForCSV = attacksRaw => {
  // each row of the .csv needs to look like this:
  // 1, 150, Straight -  Length: 153.55m Current speed: 88.51km/h, Corner - Radius: 12.56m Length: 11.22m Current speed: 32.99km/h
  return attacksRaw
    .filter(item => {
      // original_is a ref to the original attack, hence this is a recalculated attack
      return item.original_id
    })
    .map(item => {
      let breakdown = JSON.parse(item.geojson).properties.details.breakdown.map(
        item => {
          if (item.type === 'straight') {
            return {
              summary: ` Straight -  Length: ${item.length.toFixedDown(
                2
              )}m Current speed: ${item.speedCurrent.toFixedDown(2)}km/h`,
            }
          } else if (item.type === 'curve') {
            return {
              summary: ` Corner - Radius: ${item.radius.toFixedDown(
                2
              )}m Length: ${item.length.toFixedDown(
                2
              )}m Current speed: ${item.speedCurrent.toFixedDown(2)}km/h`,
            }
          }
        }
      )
      return {
        name: item.name.replace(/recalc/g, '').trim(),
        path_length: item.path_length,
        breakdown,
      }
    })
}

const DownloadCSV = () => {
  //// for when we have a DB:
  // let attacks
  // const { selectedScenarioId } = useSelector(state => state)
  // const [dataStr, setDataStr] = useState(null)
  // const { loading, error, refetch } = useQuery(GET_SCENARIO_ATTACKS, {
  //   variables: { id: selectedScenarioId },
  //   onCompleted: data => {
  //     console.log('GET_SCENARIO_ATTACKS on completed')
  //     attacks = prepareAttacksForCSV(data.scenario.attacks)
  //     console.log('DownloadCSV ', attacks)
  //     setDataStr(
  //       // eslint-disable-next-line no-undef
  //       'data:text/csv;base64,' + window.btoa(convertAttacksToCSV(attacks))
  //     )
  //   },
  // })
  // if (!dataStr) return null

  const { attacks } = useSelector(state => state)
  const dataStr =
    'data:text/csv;base64,' +
    // eslint-disable-next-line no-undef
    window.btoa(convertAttacksToCSV(prepareAttacksForCSV(attacks)))

  return (
    <>
      <Container href={dataStr} download="Attacks.csv">
        Download Attacks as .csv
      </Container>
    </>
  )
}

export default DownloadCSV
